(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read base URL from data attribute
    var baseUrl = productRecommendationsSection.dataset.baseUrl;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;

    const sectionId = window.ayrIsWomen
      ? "product-recommendations-women"
      : window.ayrIsMen
        ? "product-recommendations-men"
        : "product-recommendations-all";

    // Build request URL
    var requestUrl = baseUrl + "?section_id=" + sectionId + "&product_id=" + productId + "&limit=" + limit;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function() {
      if (request.status >= 200 && request.status < 300) {
        const tmpContainer = document.createElement("div");
        tmpContainer.innerHTML = request.response;

        const productsContainer = tmpContainer.querySelector(".products-container");
        if (!productsContainer) {
          console.log("No productsContainer", request.response);
          return;
        }
        if (productsContainer.children.length > 4) {
          const pickedProducts = [];
          for(let i = 0; i < 4; ++i) {
            const pickedIndex = Math.floor(Math.random() * productsContainer.children.length);
            const pickedChild = productsContainer.children[pickedIndex];
            pickedProducts.push(pickedChild);
            productsContainer.removeChild(pickedChild);
          }

          productsContainer.innerHTML = "";
          productsContainer.append(...pickedProducts);
        }

        productRecommendationsSection.innerHTML = tmpContainer.innerHTML;
      }
    };
    request.send();
  };

  // Listen for changes done in the Theme Editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
